import { render, staticRenderFns } from "./rijopleiding-in-stappen.vue?vue&type=template&id=2745acb4"
import script from "./rijopleiding-in-stappen.vue?vue&type=script&lang=js"
export * from "./rijopleiding-in-stappen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports